// features/auth/hooks/useLogout.ts

import { useAuthStore } from '../../../core/stores/auth.store';

export function useLogout() {
    const logout = useAuthStore((s) => s.logout);

    // No necesita useMutation porque no hay estado de loading relevante para el usuario
    // y el efecto es inmediato en el store antes de que responda el adaptador
    const handleLogout = async (): Promise<void> => {
        await logout();
    };

    return { logout: handleLogout };
}